import { render, staticRenderFns } from "./MedicalReports.vue?vue&type=template&id=f5f4dd32&scoped=true"
import script from "./MedicalReports.vue?vue&type=script&lang=js"
export * from "./MedicalReports.vue?vue&type=script&lang=js"
import style0 from "./MedicalReports.vue?vue&type=style&index=0&id=f5f4dd32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f4dd32",
  null
  
)

export default component.exports